import { ISVG } from "./UrlIcon";

export interface IAddIconProps extends ISVG {}

export const AddIcon = ({ height, width, className }: IAddIconProps) => {
    const _width = width ?? 20;
    const _height = height ?? 20;

    return (
        <svg
            width={_width}
            height={_height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path d="M9.99988 0C9.27318 0 8.68411 0.589098 8.68411 1.31577V8.68414H1.31577C0.589098 8.68414 0 9.27321 0 9.99992C0 10.7266 0.589098 11.3157 1.31577 11.3157H8.68411V18.684C8.68411 19.4107 9.27318 19.9998 9.99988 19.9998C10.7266 19.9998 11.3157 19.4107 11.3157 18.684V11.3157H18.684C19.4107 11.3157 19.9998 10.7266 19.9998 9.99992C19.9998 9.27321 19.4107 8.68414 18.684 8.68414H11.3157V1.31577C11.3157 0.589098 10.7266 0 9.99988 0Z" />
        </svg>
    );
};
